import Vue from "vue/dist/vue.js"
import store from "./store"

// ***__menu Burger__ (StarT)***
import VBurger from "vue-burger"
Vue.use(VBurger)
// ***__menu Burger__ (EnD)***

// ***__Notifications__ (StarT)***
import Notifications from "vue-notification"
Vue.use(Notifications)
/***__Notifications__ (EnD)***/

/***__Vue Select__ (StarT)***/
import vSelect from "vue-select"
Vue.component("v-select", vSelect)
import "vue-select/dist/vue-select.css"
// ***__Vue Select__ (EnD)***

/** ngProgress for ajax calls */
import NProgress from "vue-nprogress"
Vue.use(NProgress)
const nprogress = new NProgress()
import MyNProgress from './components/NProgress'
Vue.component('my-nprogress', MyNProgress);
/** ngProgress for ajax calls */

/**don't show the production tip in logs */
Vue.config.productionTip = false

/**make devtools off in production */
if (process.env.MIX_APP_ENV == 'production') {
  Vue.config.devtools = false
  Vue.config.debug = false
  Vue.config.silent = true
}

/**Header Instance */
new Vue({
  el: "#header",
  nprogress,
  store,
  data() {
    return {
      active: false,
      checked: "",
      checkedOpen: false,
      checkedClose: true,
    }
  },
  methods: {
    /**redirect login page */
    goLogin() {
      this.$nprogress.done()
      this.$nprogress.start()
      this.$nprogress.inc(0.3)
      location.href = "/login"
      setTimeout(() => {
        this.$nprogress.inc(0.6)
        this.$nprogress.done()
      }, 200);
    },

    /**go register */
    goRegister() {
      this.$nprogress.done()
      this.$nprogress.start()
      this.$nprogress.inc(0.3)
      location.href = "/register"
      setTimeout(() => {
        this.$nprogress.inc(0.6)
        this.$nprogress.done()
      }, 200);
    },

    /** UserLogin */
    UserLogin() {
      this.$nprogress.start()
      this.$router.push("/")
      this.$nprogress.done()
    },

    /**got to main page */
    mainPage() {
      this.$nprogress.done()
      this.$nprogress.start()
      this.$nprogress.inc(0.3)
      location.href = "/login"
      setTimeout(() => {
        this.$nprogress.inc(0.6)
        this.$nprogress.done()
      }, 200);
    },

    /** UserAdd */
    UserAdd() {
      this.$nprogress.start()
      this.$router.push("/register-sajam")
      this.$nprogress.done()
    },

    /** Basket */
    Basket() {
      this.$notify({
        type: "success",
        text: "Called From src/components/Header Basket Method",
        title: "Basket",
      })
    },

    /** Trade */
    Trade() {
      this.$notify({
        type: "success",
        text: "Called From src/components/Header Trade Method",
        title: "Trade",
      })
    },

    /** Lan */
    Lan() {
      this.$notify({
        type: "success",
        text: "Called From src/components/Header Lan Method",
        title: "Lan",
      })
    },
  },
})

/**Footer Instance */
new Vue({
  el: "#footer",
  store,
  nprogress,
  methods: {
    /**redirect login page */
    goLogin() {
      this.$nprogress.done()
      this.$nprogress.start()
      this.$nprogress.inc(0.3)
      location.href = "/login"
      setTimeout(() => {
        this.$nprogress.inc(0.6)
        this.$nprogress.done()
      }, 200);
    },

    /**go register */
    goRegister() {
      this.$nprogress.done()
      this.$nprogress.start()
      this.$nprogress.inc(0.3)
      location.href = "/register"
      setTimeout(() => {
        this.$nprogress.inc(0.6)
        this.$nprogress.done()
      }, 200);
    },

    //** Join in news */
    JoinInNews() {
      this.$notify({
        type: "success",
        text: "Called From src/components/Footer JoinInNews Method",
        title: "JoinInNews",
      })
    },

  },
})
